$(document).ready(function(){


    if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }

    $('html').removeAttr("style");


    // Search Container - Trigger is in secondary-navigation.twig
    $(".search-trigger").on('click', function(e) {
        e.preventDefault();
        $(".search-container").toggleClass("active");
        if ($(".search-container").hasClass("active"))
        {
            setTimeout( function()
            { 
                $('#auto-search').focus();
            }, 250);
        }

    });

    $(".search-close").on('click', function(e) {
        e.preventDefault();
        $(".search-container").removeClass("active");
    });


    /*$('h1.fancy-title, h2.block-title, h3.block-title, h2.card-title, .filter-label, .accordion-button d').html(function(i, h)
    {
        let trimmed = h.trim();

        if ($(this).children().length > 0 )
        {
            return h;
        }
        else 
        {
            return trimmed.replace(/ (.*)/, " <strong>$1</strong>");
        }
    });*/

    $(document).keyup(function(e) 
    {
        if (e.keyCode == 27) 
        { // Esc

            $('#featuredInfoWindow').slideUp(); // hide the faux infowindow on maps 
            $('#protectedDownloadsModal').modal('hide');
            $('#searchContainer').removeClass('active');

            $("html").removeClass("search-is-open");
            $("html").removeClass("nav-is-open");
            $("html").removeClass("aux-nav-is-open");

        }
    });
    


});